import React, { useEffect, useState, useRef } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useRouter } from 'next/router';

let backedRoomsArr = [];

export default function RoomsComponent(props) {
  const router = useRouter();

  let { room: room } = router.query;

  const [roomSearchField, setroomSearchField] = useState('');
  const [roomDataArr, setroomDataArr] = useState(null);
  const [roomLoader, setRoomLoader] = useState(false);

  useEffect(() => {
    if (props.roomDataArr && props.roomDataArr.length > 0) {
      setroomDataArr(props.roomDataArr);
      backedRoomsArr = [...props.roomDataArr];
    }
  }, [props.roomDataArr]);

  const searchRooms = async (e) => {
    e.preventDefault();
    setroomSearchField(e.target.value);
    let val = e.target.value;
    if (val && val !== '') {
      let filterarr = [...backedRoomsArr];
      let modifiedArr = filterarr.filter((x) =>
        x.RoomName.toLowerCase().includes(val.toLowerCase()),
      );
      let alpaarr = modifiedArr.sort(function (a, b) {
        if (a.RoomName.toLowerCase() < b.RoomName.toLowerCase()) {
          return -1;
        }
        if (a.RoomName.toLowerCase() > b.RoomName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      setroomDataArr(alpaarr);
    } else {
      setroomDataArr([...backedRoomsArr]);
    }
  };

  const submitsearchRooms = async (e) => {
    e.preventDefault();

    let val = roomSearchField;
    if (val && val !== '') {
      let filterarr = [...backedRoomsArr];
      let modifiedArr = filterarr.filter((x) =>
        x.RoomName.toLowerCase().includes(val.toLowerCase()),
      );
      let alpaarr = modifiedArr.sort(function (a, b) {
        if (a.RoomName.toLowerCase() < b.RoomName.toLowerCase()) {
          return -1;
        }
        if (a.RoomName.toLowerCase() > b.RoomName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      setroomDataArr(alpaarr);
    } else {
      setroomDataArr([...backedRoomsArr]);
    }
  };

  const selectRoom = (option) => {
    let modifiedArr = room ? (Array.isArray(room) ? [...room] : [room]) : [];

    if (modifiedArr.includes(option.id)) {
      modifiedArr.splice(modifiedArr.indexOf(option.id), 1);
    } else {
      modifiedArr.push(option.id);
    }

    console.log('modifiedArr', modifiedArr);
    props.updateRoute(['room', modifiedArr], 'addToArr');
  };

  return (
    <div className="filter__group">
      <div className="w-full">
        {roomDataArr ? (
          <Accordion className="w-full filter_group_accordion_box">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon fontSize="small" />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="filter_box_title">Rooms</Typography>
            </AccordionSummary>
            <AccordionDetails
              className="flex flex-col"
              style={{ paddingTop: 0 }}
            >
              <form onSubmit={(e) => submitsearchRooms(e)}>
                <TextField
                  placeholder="Search"
                  type="text"
                  variant="outlined"
                  fullWidth
                  list="collections"
                  size="small"
                  onChange={(e) => {
                    searchRooms(e);
                  }}
                  value={roomSearchField}
                  InputProps={{
                    endAdornment: (
                      <>
                        {roomSearchField.length > 0 && (
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              setroomSearchField('');
                              setRoomLoader(false);
                              // getMarketPlaceData()
                              setroomDataArr([...backedRoomsArr]);
                            }}
                            size="small"
                          >
                            <CancelRoundedIcon />
                          </IconButton>
                        )}
                        <IconButton
                          aria-label="search"
                          type="submit"
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      </>
                    ),
                  }}
                />
              </form>
              <div className="py-3">
                {roomDataArr && (
                  <PerfectScrollbar className="collection_filter_list_box">
                    <List dense id="collections">
                      {roomDataArr.map((option, index2) => {
                        const labelId = `checkbox-list-secondary-label-${index2}`;
                        return (
                          <ListItem
                            key={index2}
                            button
                            onClick={() => {
                              selectRoom(option);
                            }}
                          >
                            <ListItemText
                              id={labelId}
                              primary={`${option.RoomName}`}
                              className="wrapWords"
                            />
                            <ListItemSecondaryAction>
                              <Checkbox
                                edge="end"
                                onChange={(e) => {
                                  selectRoom(option);
                                }}
                                checked={
                                  room
                                    ? Array.isArray(room)
                                      ? room.includes(option.id)
                                      : option.id === room
                                    : false
                                }
                                inputProps={{
                                  'aria-label': 'primary checkbox',
                                }}
                              />
                            </ListItemSecondaryAction>
                          </ListItem>
                        );
                      })}
                    </List>
                  </PerfectScrollbar>
                )}
              </div>
            </AccordionDetails>
          </Accordion>
        ) : (
          <div className="w-full filter_group_accordion_box rounded-md">
            <div className="py-4">
              <div className="flex justify-between px-4">
                <div className="filter_box_title MuiTypography-body1">
                  Rooms
                </div>
                <svg
                  focusable="false"
                  width={20}
                  height={20}
                  fill="#0000008a"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
